export default __webpack_public_path__ + "static/media/solace pro_connect.107ee14e.png";